export default "__VITE_ASSET__Be2WUlLg__"